/**
 * Тексты уведомлений — утверждены владельцем (CC_PROMPT_S4_NOTIFY_AVATARS_EMOJI.md
 * CC_PROMPT_S4_2.md и CC_PROMPT_S4_3.md, «Тексты»).
 */
export const NTX = {
    enable: "Включить уведомления",
    /** Подсказка колокольчика после ответа браузера (S4.2). */
    enabled: "Уведомления включены",
    denied: "Уведомления запрещены в браузере",
    /** Переключатель приложения (S4.3): состояние и действие по клику. */
    disabled: "Уведомления выключены",
    turnOff: "Выключить уведомления",
    turnOn: "Включить уведомления",
    /** VIN во всех текстах — маска «***3761» (S6, maskVin). */
    alertTitle: (vin: string) => `Алерт · ${vin}`,
    /** Мигание заголовка вкладки, пока алерт никто не взял (S4.2). */
    alertBlink: (vin: string) => `Алерт · ${vin}`,
    /** Машина пришла на наш этап (S4.2): всплывающее и заголовок системного уведомления. */
    arrived: (vin: string, stage: string) => `${vin} → «${stage}»`,
    /** Веха поставлена вручную (S9): всплывающее и заголовок системного уведомления. */
    milestoneDone: (vin: string, milestone: string) => `${vin} · ${milestone} — готово`,
    milestoneIssue: (vin: string, milestone: string) => `${vin} · ${milestone} — с замечанием`,
    messageTitle: (author: string, vin: string) => `${author} · ${vin}`,
    generalTitle: (author: string) => `${author} · Общий чат`,
    attachment: "Вложение",
    /** Заголовок вкладки: бренд как в public/index.html. */
    brand: "ATOM EoL",
} as const;
